import React, { useState, useRef } from 'react'
import { Validaciones } from '@renedelangel/helpers';

// Redux
import { useSelector } from 'react-redux';
// master components
import Tabla from '../../../_layout/masterComponents/Tabla';
import FormularioModal from '../../../_layout/masterComponents/FormularioModal';

// generic components
import SweetAlert from '../../../_layout/genericComponents/ModalConfirmacion';

// material-ui icons
import Add from "@material-ui/icons/Add";
import Edit from "@material-ui/icons/Edit";
import Close from "@material-ui/icons/Close";
import SyncIcon from '@material-ui/icons/Sync';
import SaveIcon from '@material-ui/icons/Save';
import PersonIcon from '@material-ui/icons/Person';

import { getResponsablesSeguro, tablaResponsablesSeguro } from '../../../querys/ResponsablesSeguro';
import { deleteResponsablesSeguro, addResponsablesSeguro, updateResponsablesSeguro } from '../../../mutations/ResponsablesSeguro';

import { handleFocus, handleErrorInputText, handleModificar, handelAlertEliminar, handleEliminar, handleGuardar } from '../../../_layout/helpers/handles';
import { info, danger, success, primary } from '../../../_layout/helpers/colores';

import * as Permisos from '../Permisos';

const { trim } = Validaciones;

// Longitud de la columna RESPONSABLE en tblresponsablesseguro
const maxResponsable = 30;

function ResponsablesSeguro() {

    const { token } = useSelector(state => state.login);

    const cleanState = {
        responsableID: null,
        responsable: ""
    };
    const cleanErrorState = {
        responsable: { error: false, helperText: "" }
    }

    const cleanNotificaciones = { mensaje: "", color: null, open: false };
    const [state, setState] = useState(cleanState);
    const [errorState, setErrorState] = useState(cleanErrorState);
    const [notificaciones, setNotificaciones] = useState(cleanNotificaciones);
    const [open, setOpen] = useState(false);
    const [disabled, setDisabled] = useState(false);
    const [alert, setAlert] = useState(null);
    const [loader, setLoader] = useState(false);
    const [actualizar, setActualizar] = useState(false);

    let titleAccion = state.responsableID ? "Modificar" : "Agregar";
    let titleModal = `${titleAccion} Responsable`;

    const responsableRef = useRef(null);

    let acciones = [{
        accionID: [1, 3],
        icono: Edit,
        color: info,
        descripcion: "Modificar",
        parametros: [{ campo: "responsableID" }],
        disabled: { multiseleccion: true },
        onClick: (parametros) => handleModificar({
            parametros, token, setState, setOpen, setAlert,
            asyncGet: getResponsablesSeguro
        })
    }, {
        accionID: [4],
        icono: Close,
        color: danger,
        descripcion: "Eliminar",
        parametros: [{ campo: "responsableID" }, { campo: "responsable" }],
        disabled: { multiseleccion: true },
        onClick: ({ responsableID, responsable }) => handelAlertEliminar({
            setAlert,
            mensaje: ` al responsable ${responsable}`,
            onCancel: () => setAlert(null),
            onConfirm: () => handleEliminar({
                token, setAlert, setActualizar, actualizar,
                parametros: { responsableID }, asyncDelete: deleteResponsablesSeguro
            })
        })
    }];

    let botones = [
        {
            accionID: [2],
            icono: Add,
            color: success,
            descripcion: "Agregar",
            onClick: () => setOpen(true),
            disabled: { multiseleccion: true }
        }, {
            icono: SyncIcon,
            color: info,
            descripcion: "Actualizar",
            onClick: () => setActualizar(!actualizar),
            disabled: { multiseleccion: true }
        }];

    const infoTabla = {
        botones,
        acciones,
        loader,
        actualizar,
        id: "responsableID",
        color: primary,
        title: "Responsables",
        iconTable: <PersonIcon />,
        headers: [
            { variable: "responsableID", descripcion: "ResponsableID", hide: true },
            { variable: "responsable", descripcion: "Responsable" }
        ],
        responsiveTitle: ["responsable"],
        filter: [
            { campo: "responsable" }
        ],
        alineacion: [{ columnas: [0, 1, 2], alineacion: "left" }]
    }

    const inputs = [
        {
            id: "Arriba",
            tipo: "fieldset",
            grid: { lg: 12 },
            inputs: [
                {
                    disabled,
                    id: "responsable",
                    value: state.responsable,
                    error: errorState.responsable.error,
                    success: state.responsable && !errorState.responsable.error ? true : undefined,
                    helperText: errorState.responsable.helperText,
                    inputRef: responsableRef,
                    title: "Responsable *",
                    placeholder: "Capture el nombre del responsable",
                    grid: { md: 12, lg: 12 },
                    onChange: ({ target: { value } }) => {
                        handleChange(value.toUpperCase(), "responsable")
                    },
                    onKeyDown: () => { return; }
                }
            ]
        }
    ];

    let accionesFormulario = [{
        accionID: state.responsableID ? [3] : [2],
        loader,
        disabled,
        icono: SaveIcon,
        color: info,
        descripcion: "Guardar",
        onClick: () => handleGuardar({
            setLoader,
            setDisabled,
            setActualizar,
            actualizar,
            setNotificaciones,
            handleClose,
            handleFocus,
            refFocus: responsableRef,
            mensajeCorrecto: `El responsable se ${state.responsableID ? "actualizó" : "agregó"} correctamente`,
            asyncCallback: ftGuardar,
        }),
    }, {
        disabled,
        icono: Close,
        color: danger,
        descripcion: "Cancelar",
        onClick: handleClose
    }];

    function ftErrorInputText({ condicion, ref, keyError, mensajeError }) {
        return handleErrorInputText({
            cleanErrorState, condicion, ref, keyError, mensajeError,
            loader: setLoader, disabled: setDisabled, errorState: setErrorState
        });
    }

    function handleValidaciones({ responsable }) {

        let error;
        let validaciones = [
            {
                condicion: !responsable || trim(responsable) === "",
                ref: responsableRef, keyError: "responsable",
                mensajeError: "Debe especificar el nombre del responsable"
            },
            {
                condicion: trim(responsable).length > maxResponsable,
                ref: responsableRef, keyError: "responsable",
                mensajeError: `El nombre no debe exceder de ${maxResponsable} caracteres`
            }
        ];
        validaciones.forEach(({ condicion, ref, keyError, mensajeError }) => {
            if (error) return;
            error = ftErrorInputText({ condicion, ref, keyError, mensajeError });
        });

        if (error) return error;

    }

    function ftGuardar() {
        async function ftGuardar() {

            let { responsableID, responsable } = state;

            let error = await handleValidaciones({ responsable });

            if (error) return error;

            if (responsableID) await updateResponsablesSeguro({
                input: { responsableID, responsable: trim(responsable) }
            }, token);
            else await addResponsablesSeguro({
                input: { responsable: trim(responsable) }
            }, token);

        }
        return ftGuardar();
    }

    function handleClose() {
        setOpen(false);
        setDisabled(false);
        setLoader(false);
        setNotificaciones({ ...cleanNotificaciones });
        setState({ ...cleanState });
        setErrorState({ ...cleanErrorState });
    }

    function handleChange(value, key) { setState({ ...state, [key]: value }); }

    const [accionesUsr, setAccionesUsr] = useState();
    if (accionesUsr) {
        acciones = Permisos.ValidarAcciones(acciones, accionesUsr);
        botones = Permisos.ValidarAcciones(botones, accionesUsr);
        accionesFormulario = Permisos.ValidarAcciones(accionesFormulario, accionesUsr);
    } else {
        Permisos.PermisosAState(setAccionesUsr, token);
    }

    return (<>
        <Tabla
            infoTabla={infoTabla}
            asyncData={tablaResponsablesSeguro}
            token={token}
        />
        <FormularioModal
            open={open}
            title={titleModal}
            onClose={handleClose}
            notificaciones={notificaciones}
            closeNotification={() => setNotificaciones({ ...cleanNotificaciones })}
            inputs={inputs}
            maxWidth={false}
            acciones={accionesFormulario}
            focus={responsableRef}
        />
        {alert && <SweetAlert
            title={alert.title}
            descripcion={alert.descripcion}
            tipo={alert.tipo}
            msjConfirmacion={alert.msjConfirmacion}
            msjCancelacion={alert.msjCancelacion}
            onConfirm={alert.onConfirm}
            showConfirm={alert.showConfirm}
            showCancel={alert.showCancel}
            onCancel={() => setAlert(null)}
        />}
    </>);

}

export default ResponsablesSeguro;
